import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: (p) => p.spacing(1),
};

export const showMore: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption,
  fontWeight: 600,
  cursor: 'pointer',
};

export const showMoreIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
  cursor: 'pointer',
};
